import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GetUserProfileResponse} from '../responses/GetUserProfileResponse';
import {EndpointService} from './endpoint.service';
import {GetUserAddressesRequest} from '../requests/GetUserAddressesRequest';
import {GetUserAddressesResponse} from '../responses/GetUserAddressesResponse';
import {BaseResponse} from '../responses/BaseResponse';
import {Patch} from '../models/patch';
import {AddAddressRequest} from '../requests/AddAddressRequest';
import {ChangePasswordRequest} from '../requests/ChangePasswordRequest';
import {FilePostRequest} from '../requests/FilePostRequest';
import {FilePostResponse} from '../responses/FilePostResponse';

@Injectable({providedIn: 'root'})
export class UserService {
  constructor(private _http: HttpClient) {
  }

  getUserProfile(userId: string) {
    return this._http.get<GetUserProfileResponse>(EndpointService.getUserProfileInfo + `?userId=${userId}`);
  }

  getUserAddresses(data: GetUserAddressesRequest) {
    return this._http.post<GetUserAddressesResponse>(EndpointService.getUserAddresses, data);
  }

  editUserAddress(data: Array<Patch>, addressId: number) {
    return this._http.patch<BaseResponse>(EndpointService.editUserAddress + `?id=${addressId}`, data);
  }

  addUserAddress(data: AddAddressRequest) {
    return this._http.post<BaseResponse>(EndpointService.addUserAddress, data);
  }

  editUser(data: Array<Patch>, userId: string, accessToken?: string) {
    const body = {
        id: userId,
        userPatch: data
    };
    if(accessToken) {
      return this._http.patch<BaseResponse>(EndpointService.editUser, body, {
        headers: {
          "Authorization": `Bearer ${accessToken}`
        }
      });
    }
    return this._http.patch<BaseResponse>(EndpointService.editUser, body);
  }

  deleteAddresses(data: Array<Patch>, addressId: number) {
    return this._http.patch<BaseResponse>(EndpointService.deleteUserAddress + `?id=${addressId}`, data);
  }

  changePassword(data: ChangePasswordRequest) {
    return this._http.post<BaseResponse>(EndpointService.changePassword, data);
  }

  changeProfilePicture(data: FilePostRequest) {
    return this._http.post<FilePostResponse>(EndpointService.changeProfilePicture, data);
  }

  deleteProfilePicture() {
    return this._http.post<BaseResponse>(EndpointService.deleteProfilePicture, {});
  }
}
